import { UpsPermissionType } from '../../../../../shared/type/permission';

export const hasNoUpsPermission = (
  permission: UpsPermissionType,
  permission_target: keyof UpsPermissionType,
): boolean => {
  if (!permission_target) {
    console.error('hasNoUpsPermission 함수에는 permission_target 이 필수 입니다.');
  }

  switch (permission_target) {
    case 'membership':
      return (
        permission && permission.membership?.is_membership_product && !permission.membership?.has_permission
      );
  }
};
